module.exports = __webpack_public_path__ + "img/m4x6maodingmu.prt.b34580ce.jpg";